export default class RegistrationStep extends Backbone.Model
  defaults:
    currentStep: "chooseMethod"
    addMethod: "scrapeClient"
    showSkip: false

  nextStep: ->
    # chooseMethod -> addProject -> import -> review
    switch @get("currentStep")
      when "chooseMethod"
        @set(currentStep: "addProject")
      when "addProject"
        @set(currentStep: "import")
      when "import"
        @set(currentStep: "review")

  reset: ->
    @set
      currentStep: "chooseMethod"
      addMethod: "scrapeClient"



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/models/registration_step.js.coffee